var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoute } from 'ziggy-js';
import useTypedPage from '@/Hooks/useTypedPage';
import JetFormSection from '@/Jetstream/FormSection';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import { useForm } from '@inertiajs/react';
import classNames from "classnames";
import JetActionMessage from "../../Jetstream/ActionMessage";
import JetButton from "../../Jetstream/Button";
import { Ziggy } from "@/ziggy";
export default function CreateTeamForm() {
    var route = useRoute(Ziggy);
    var page = useTypedPage();
    var form = useForm({
        name: '',
    });
    function createTeam() {
        form.post(route('teams.store'), {
            errorBag: 'createTeam',
            preserveScroll: true,
        });
    }
    return (_jsxs(JetFormSection, __assign({ onSubmit: createTeam, title: 'Create a new team', description: 'Create a new team to collaborate with others on projects.', renderActions: function () { return _jsxs("div", { children: [_jsx(JetActionMessage, __assign({ on: form.recentlySuccessful, className: "mr-3" }, { children: "Saved." })), _jsx(JetButton, __assign({ className: classNames({ 'opacity-25': form.processing }), disabled: form.processing }, { children: "Save" }))] }); } }, { children: [_jsxs("div", __assign({ className: "col-span-6" }, { children: [_jsx(JetLabel, { value: "Team owner's account" }), _jsxs("div", __assign({ className: "flex items-center mt-2" }, { children: [_jsx("img", { className: "w-12 h-12 rounded-full object-cover", src: page.props.user.profile_photo_url, alt: page.props.user.name }), _jsxs("div", __assign({ className: "ml-4 leading-tight" }, { children: [_jsx("div", { children: page.props.user.name }), _jsx("div", __assign({ className: "text-gray-700 text-sm" }, { children: page.props.user.email }))] }))] }))] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, { htmlFor: "name", value: "Team name" }), _jsx(JetInput, { id: "name", type: "text", className: "mt-1 block w-full", value: form.data.name, onChange: function (e) { return form.setData('name', e.currentTarget.value); }, autoFocus: true }), _jsx(JetInputError, { message: form.errors.name, className: "mt-2" })] }))] })));
}
